<template>
    <div class="data_body">
        <div style="width: 100%; height: 100%">
            <div id="charts_canvas" class="echart" style="width: 100%; height: 100%; "></div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        yearArray: {
            type: Array,
        },
    },
    data() {
        return {
            chartObj: null,
            ooption: {
                xdata: [],
                sdata: [],
            },
            option: {
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '70%',
                        data: [
                            { value: 1, name: '指导培养青年教师' },
                            { value: 29, name: '指导学生' },
                            { value: 81, name: '业务比赛获奖' },
                            { value: 18, name: '课例获奖' },
                            { value: 4, name: '发表论文' }
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            },
        };
    },
    methods: {
        setChart(option) {
            // 雷达图显示的标签
            let newPromise = new Promise((resolve) => {
                resolve();
            });
            //然后异步执行echarts的初始化函数
            newPromise.then(() => {
                const chartObj = this.$echarts.init(
                    //劳动课程
                    this.$el.querySelector("#charts_canvas")
                );

                // this.option.xAxis.data = option.xdata;
                // this.option.series[0].data = option.sdata;
                // this.option.visualMap.max = option.max ? option.max : 0;

                // 初始化雷达图
                this.chartObj = chartObj;
                this.chartObj.setOption(this.option);
            });
        },
    },
    watch: {
        yearArray: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.ooption = {
                    xdata: [],
                    sdata: [],
                    max: 0
                }
                let _array = newValue
                let max = []
                for (var i = 0; i < _array.length; i++) {
                    this.ooption.xdata.push(_array[i].Month + '月')
                    this.ooption.sdata.push([i, 0, _array[i].sun])
                    this.ooption.sdata.push([i, 1, _array[i].mon])
                    this.ooption.sdata.push([i, 2, _array[i].tue])
                    this.ooption.sdata.push([i, 3, _array[i].wed])
                    this.ooption.sdata.push([i, 4, _array[i].thur])
                    this.ooption.sdata.push([i, 5, _array[i].fri])
                    this.ooption.sdata.push([i, 6, _array[i].sat])
                    // let _data = [_array[i].Month-1,] //[月份，星期，值]
                    max.push(_array[i].sun)
                    max.push(_array[i].mon)
                    max.push(_array[i].tue)
                    max.push(_array[i].wed)
                    max.push(_array[i].thur)
                    max.push(_array[i].fri)
                    max.push(_array[i].sat)
                }
                this.ooption.max = max.sort(function (a, b) {
                    return b - a;
                })[0];
                if (!this.chartObj) {
                    this.setChart(this.ooption);
                } else {
                    this.option.xAxis.data = this.ooption.xdata;
                    this.option.series[0].data = this.ooption.sdata;
                    this.option.visualMap.max = this.ooption.max ? this.ooption.max : 0;
                    this.chartObj.setOption(this.option);
                }
                this.$forceUpdate();
            },
        },
    },
    mounted() {
        this.ooption = {
            xdata: [],
            sdata: [],
            max: 0
        }
        let _array = this.yearArray
        let max = []
        for (var i = 0; i < _array.length; i++) {
            this.ooption.xdata.push(_array[i].Month + '月')
            this.ooption.sdata.push([i, 0, _array[i].sun])
            this.ooption.sdata.push([i, 1, _array[i].mon])
            this.ooption.sdata.push([i, 2, _array[i].tue])
            this.ooption.sdata.push([i, 3, _array[i].wed])
            this.ooption.sdata.push([i, 4, _array[i].thur])
            this.ooption.sdata.push([i, 5, _array[i].fri])
            this.ooption.sdata.push([i, 6, _array[i].sat])
            // let _data = [_array[i].Month-1,] //[月份，星期，值]
            max.push(_array[i].sun)
            max.push(_array[i].mon)
            max.push(_array[i].tue)
            max.push(_array[i].wed)
            max.push(_array[i].thur)
            max.push(_array[i].fri)
            max.push(_array[i].sat)
        }
        this.ooption.max = max.sort(function (a, b) {
            return b - a;
        })[0];

        this.setChart(this.ooption);
        var _this = this;
        window.addEventListener("resize", () => {
            if (_this.chartObj) {
                _this.chartObj.resize();
            }
        });
    },
};
</script>
  
<style scoped>
.data_body {
    height: 100%;
    position: relative;
    border-radius: 5px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0;
    width: 95%;
    background: #fff;
}
</style>
  


// WEBPACK FOOTER //
// src/components/pages/dataBoardSies/school/loginTime/index.vue